(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-form"] && !Shopify.designMode) return;
  try {
    // Honeypot + memoire locale : une fois inscrit, la popup ne doit plus reapparaitre.
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.newsletter-form');
    if (!form) return;

    const honeypot = form.querySelector('input[name="company"]');
    if (honeypot && honeypot.value !== '') {
      event.preventDefault();
      return;
    }

    const inner = form.querySelector('[data-newsletter-source]');
    try {
      localStorage.setItem('newsletter_subscribed', '1');
      if (inner) {
        sessionStorage.setItem('newsletter_last_source', inner.dataset.newsletterSource || '');
      }
    } catch (error) {
      // Navigation privee : on laisse passer, la popup se contentera de la session.
    }
  });

  // Shopify redirige avec ?customer_posted=true apres une inscription reussie.
  if (window.location.search.indexOf('customer_posted=true') !== -1) {
    try {
      localStorage.setItem('newsletter_subscribed', '1');
    } catch (error) {
      /* noop */
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const thumbnails = document.querySelectorAll('.product-gallery__thumbnail');
    const mainImageContainer = document.querySelector('[data-product-gallery-main]');

    if (!mainImageContainer) return;

    function updateMainImage(thumbnail) {
      if (!thumbnail) return;

      const mediaSrc = thumbnail.dataset.mediaSrc;

      if (mediaSrc) {
        const mainImg = mainImageContainer.querySelector('.product-gallery__image');

        if (mainImg) {
          mainImg.src = mediaSrc;
          mainImg.srcset = '';
        }

        thumbnails.forEach(t => t.classList.remove('product-gallery__thumbnail--active'));
        thumbnail.classList.add('product-gallery__thumbnail--active');
      }
    }

    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', function(e) {
        e.preventDefault();
        updateMainImage(this);
      });
    });

    document.addEventListener('variant:change', function(event) {
      const variant = event.detail.variant;
      if (variant && variant.featured_media && variant.featured_media.id) {
        const thumbnail = document.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
        if (thumbnail) {
          updateMainImage(thumbnail);
        }
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
